import axios from "axios";

const fetch = email =>
  axios.get("/logged_in_organizations", { params: { email } });

const loggedInOrganizationsApi = { fetch };

export default loggedInOrganizationsApi;
